import clsx from "clsx";

import { Icon } from "@atoms/icon";

import classes from "./styles.module.scss";

import type { IInputIconProps } from "./types";

export function InputIcon(props: IInputIconProps) {
  const {
    iconName = "CloseLine",
    fontSize = "fs-20",
    children,
    className,
    onMouseDown,
    onClick,
    ...rest
  } = props;

  return (
    <button
      onMouseDown={(event) => {
        event.stopPropagation();
        event.preventDefault();
        onMouseDown?.(event);
      }}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.(event);
      }}
      className={clsx(classes["input-icon"])}
      type={"button"}
      {...rest}
    >
      <Icon name={iconName} fontSize={fontSize} />
    </button>
  );
}
